import React from 'react';

import { Container } from './styles';

const ErrorBoxSubmit = () => {
  return <Container>* Erros de validação do formulário. Verifique!</Container>;
};

export default ErrorBoxSubmit;
